import { render } from "./ResultSum.vue?vue&type=template&id=6acd4013&scoped=true"
import script from "./ResultSum.vue?vue&type=script&lang=js"
export * from "./ResultSum.vue?vue&type=script&lang=js"

import "./ResultSum.vue?vue&type=style&index=0&id=6acd4013&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acd4013"]])

export default __exports__